import { createQueryClient } from '@healthinal/react-error-utils/tanstack-query';

export const queryClient = createQueryClient();
